import Component from "../Component";
import {domSelectors} from "../../globals";
import {getApi, userInfo} from "../../auth";
import $ from "jquery";
import Page from "../../pages/Page";
import {consensiUtente, salvaConsenso} from "../../privacy";
import UI from "../../ui";
import pure from "pure";
import { subscribeNewsletterNoConfirm, unsubscribeNewsletter } from "../../mailup";
import "../../globals";
import * as bootstrap from "bootstrap";
import * as bootbox from "bootbox";
import { t } from "~/hooks/useI18n";

class PrivacyModal extends Component {
    
    private _consensi:any;
    
    private _intent: { resolve: (value: string | PromiseLike<string>) => void; reject: (reason?: any) => void; };
    private _promise: Promise<string> | undefined;
    private _compiledTemplate: any = null;
    constructor() {
        super(domSelectors.PrivacyModal, true);
        this._intent = { resolve: () => {}, reject: () => {} }; 
    }
    
    public get consensi():any {
        return this._consensi; 
    }
    
    public set consensi(consensi:any) {
        this._consensi = consensi;
    }
    
    public async activate(): Promise<void> {
        const self = this;
        const elemPrivacy = this.domElement;
        
        $(elemPrivacy).modal();
        $(elemPrivacy).on("shown.bs.modal", e => {
            Page.current.signInModal?.hide(); //quando mostro il modale privacy, nascondo il modale di login
        });
        
        $(domSelectors.PrivacyModalAcceptButton)
                .off("click")
                .on("click", async e => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (await this.acceptAndSave()) {
                        //TODO: concatenare con la promise di chiamata a ChangeSettings
                        $(elemPrivacy).modal("hide"); // nascondi la modale
                        // console.log("Promise risolta con 'saved'");
                        self._intent.resolve("saved");
                    }
                    return false;
                });

        $(domSelectors.PrivacyModalCancelButton)
                .off("click")
                .on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(elemPrivacy).modal("hide"); // nascondi la modale
                    self._intent.resolve("cancelled");
                    return false;
                });
        
        this.currentPage.spinner.stop(); //TODO: forse non deve stare qui
    }

    public acquisisciConsensi() {
        this._promise = new Promise((resolve, reject) => {
            this._intent = { resolve, reject };
        });
        
        this.loadConsensi(); //carico i consensi e renderizzo il template
        
        $("#modal-privacy").modal("show");
        return this._promise;
    }
    
    private async loadConsensi(): Promise<void> {
        this._consensi = await consensiUtente();
      

        const self = this;
        const userInfo = getApi().getCached("userInfo");
        const modalElement = document.getElementById("modal-privacy");
        
        //console.log("===>", $(domSelectors.PrivacyModalTemplate), this._consensi);
        
        // Verifica se ci sono consensi scaduti
        const hasConsensiScaduti = this._consensi.consensi?.some((c: any) => c.scaduto === true) || false;
        
        // Se ci sono consensi scaduti, dechecka i consensi obbligatori scaduti
        if (hasConsensiScaduti && this._consensi.consensi) {
            this._consensi.consensi.forEach((consenso: any) => {
                if (consenso.scaduto && consenso.obbligatorio && consenso.checked) {
                    consenso.checked = false;
                }
                // I consensi facoltativi scaduti mantengono il loro stato checked
            });
        }
        
        $(domSelectors.PrivacyModalTemplate).render(this._consensi, this.getTemplatePrivacy());

        // Gestione visualizzazione titoli e messaggi in base ai consensi scaduti
        if (hasConsensiScaduti) {
            modalElement?.querySelectorAll(".modal-title.default, .messageToUser.default").forEach(elem => {
                elem.classList.add("d-none");
            });
            modalElement?.querySelectorAll(".modal-title.review, .messageToUser.review").forEach(elem => {
                elem.classList.remove("d-none");
            });
        } else {
            modalElement?.querySelectorAll(".modal-title.default, .messageToUser.default").forEach(elem => {
                elem.classList.remove("d-none");
            });
            modalElement?.querySelectorAll(".modal-title.review, .messageToUser.review").forEach(elem => {
                elem.classList.add("d-none");
            });
        }

        this.domElement?.querySelectorAll("input.checkboxPrivacy").forEach(elem => {
            elem.addOrReplaceEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                const checkbox = e.currentTarget as HTMLInputElement;
                let stato = ($(checkbox).prop("checked") ? 1 : 0);
                let consensoId = $(checkbox).attr('rifid') as unknown as number;
                let codice = $(checkbox).attr('data-codice');

                console.log("consensoId", consensoId, "codice", codice, "stato", stato);
                if (!isNaN(consensoId) && codice !== undefined)
                    try {
                        await salvaConsenso(consensoId, codice, stato);
                    } catch (e) {
                        console.error(e);
                        self._intent.reject("error");
                    }

                // ✅ Gestione consenso NEWS (iscrizione/disiscrizione newsletter)
                if (codice === "NEWS") {
                    try {
                        if (stato == 1) {
                            // ✅ ISCRIZIONE alla newsletter
                            console.info("📧 Iscrizione newsletter per:", userInfo.email);
                            await subscribeNewsletterNoConfirm(
                                window.ATP_ListID_Newsletter,
                                window.ATP_GroupId_Registrazione,
                                userInfo.email
                            );
                        } else {
                            // ✅ DISISCRIZIONE dalla newsletter
                            console.info("📧 Disiscrizione newsletter per:", userInfo.email);
                            await unsubscribeNewsletter(
                                window.ATP_ListID_Newsletter,
                                userInfo.email
                            );
                        }
                    } catch (error) {
                        console.error("❌ Errore gestione newsletter:", error);
                        UI.confirmOneButton("", t("messages.errorNewsletterOperation"), "OK");
                    }
                }

                await self.loadConsensi(); //ricarico il modal con dati aggiornati dal server, SENZA creare una nuova promise
            });
        })
    }
    
    private async acceptAndSave(): Promise<boolean> {
        
        let uncheckedObbligatorio = this.domElement
            ?.querySelector( 
                "input[type=checkbox][obbligatorio=true]:not(:checked)" );
        
        let checkboxes = this.domElement?.querySelectorAll("input[type=checkbox].form-check-input");
        
        if (!uncheckedObbligatorio) { // tutti i consensi obbligatori sono stati accettati
            // salvo i consensi checkati
            const consensi: Array<{ consensoId: number, checked: boolean }> = [];
            checkboxes?.forEach(elem => {
                const consensoId = parseInt(elem.getAttribute("rifid") || '-1');
                if (isNaN(consensoId) || consensoId === -1) return; // se non riesco a recuperare un consensoId valido, salto questo elemento
                const checked = (elem as HTMLInputElement).checked;
                consensi.push({
                    consensoId: consensoId,
                    checked: checked
                });
            })
            
            // Chiama l'endpoint PUT /privacy/consensiUtente
            // Se questo fallisce, l'errore viene propagato e gestito dalla classe base
            await getApi().fetchWithAuth("PUT /privacy/consensiUtente", {
                body: JSON.stringify({ consensi: consensi }) 
            });
            
            await userInfo(true); //forzo il reload del profilo utente per aggiornare lo stato dei consensiIncompleti e ATP
            return true;
        } else {
            await UI.confirmOneButton("", t("messages.errPrivacyConsensiObbligatoriAccessoAR"));
            return false;
        }
    }
    private getTemplatePrivacy() {
        if (this._compiledTemplate !== null) return this._compiledTemplate; 

        const directive = {
            '#Abstract': 'abstract',
            '#LinkPrivacy@href': 'link',
            '.template-riga': {
                'consenso<- consensi': {
                    '#DescrizioneConsenso': 'consenso.descrizione',
                    '#LinkConsenso@href': 'consenso.linkModulo',
                    'input.checkboxPrivacy@rifid': function (a:any) {
                        return a.item.consensoId;
                    },
                    'input.checkboxPrivacy@checked': function (a:any) {
                        return a.item.checked;
                    },
                    'input.checkboxPrivacy@obbligatorio': function (a:any) {
                        return a.item.obbligatorio;
                    },
                    'input.checkboxPrivacy@data-codice': function (a:any) {
                        return a.item.codice;
                    }
                }
            }
        };
        return (this._compiledTemplate = $(domSelectors.PrivacyModalTemplate).compile(directive));
    }
    destroy(): void {
        if (this.domElement) {
            $(this.domElement).modal("hide");
            $(this.domElement).modal("dispose");
        }
    }
}

export default PrivacyModal;